import {FC} from 'react'
import {ColumnInstance} from 'react-table'
import {Campaign,CampaignMessage} from '../../../../../../models/Campaign'

type Props = {
  column: ColumnInstance<CampaignMessage>
}

const CustomHeaderColumn: FC<Props> = ({column}) => (
  <>
    {column.Header && typeof column.Header === 'string' ? (
      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
    ) : (
      column.render('Header')
    )}
  </>
)

export {CustomHeaderColumn}
